export const ADMIN_VERSION_KEY = 'admin-version';
